<template>
  <q-dialog
      class="dialog"
  >
    <q-card :style="$isDesktop ? 'min-width: 350px': ''">
      <common-form :action="$route('auth.request-reset')">
        <q-card-section class="row items-center" :class="{'q-px-lg': $isDesktop}">
          <div class="dialog__title">Wachtwoord vergeten</div>
          <q-space />
          <icon-button
              icon="close"
              aria-label="Sluit het dialoogvenster"
              round
              dense
              v-close-popup
          />
        </q-card-section>
        <q-card-section class="q-px-lg q-pt-none">
          <common-input
              v-model="form.email"
              label="E-mailadres"
              type="email"
              name="email"
              :error-message="$errorMessage('email')"
              :error="$hasError('email')"
              autofocus
          />
        </q-card-section>
        <q-separator />
        <q-card-actions :class="$isMobile ? 'q-pa-md' : 'q-px-lg q-py-md'">
          <accent-button
              label="Vraag reset aan"
              type="submit"
              v-close-popup
          />
          <flat-button
              label="Annuleren"
              v-close-popup
          />
        </q-card-actions>
      </common-form>
    </q-card>
  </q-dialog>

</template>

<script>
export default {
  data () {
    return {
      form: {
        email: '',
      },
    }
  },
}
</script>
